// 8.3.7 — learner level control (merged into the locale as `lvl`).
const lvl = {
  "changeLevel": "Change level",
  "title": "Change your {lang} level",
  "help": "Choose the level that feels right for you. You can change it anytime.",
  "safe": "Your saved words, reviews and progress won't be lost.",
  "save": "Save level",
  "cancel": "Cancel",
  "saving": "Saving…",
  "changed": "Level changed to {level}. Future practice will adapt to your new level.",
  "failed": "Couldn't change your level. Try again.",
  "current": "Current",
  "profilesHelp": "Your language profile and its CEFR level. Changing the level only affects future practice.",
  "levels": {
    "A1": {
      "name": "Beginner",
      "desc": "Basic words and simple everyday phrases."
    },
    "A2": {
      "name": "Elementary",
      "desc": "Familiar situations and short conversations."
    },
    "B1": {
      "name": "Intermediate",
      "desc": "Handle everyday conversations with growing independence."
    },
    "B2": {
      "name": "Upper intermediate",
      "desc": "Discuss many topics naturally and understand more complex language."
    },
    "C1": {
      "name": "Advanced",
      "desc": "Express ideas fluently and handle nuanced language."
    },
    "C2": {
      "name": "Highly proficient",
      "desc": "Understand and express almost anything with precision."
    }
  }
};
export default lvl;
